(() => {
  const initFaq = (section) => {
    if (!section || section.dataset.coastaFaqReady === 'true') return;
    section.dataset.coastaFaqReady = 'true';
    const input = section.querySelector('[data-coasta-faq-search]');
    const clear = section.querySelector('[data-coasta-faq-clear]');
    const reset = section.querySelector('[data-coasta-faq-reset]');
    const empty = section.querySelector('[data-coasta-faq-empty]');
    const questions = [...section.querySelectorAll('[data-coasta-faq-question]')];
    const groups = [...section.querySelectorAll('.coasta-faq-group')];
    const categoryLinks = [...section.querySelectorAll('[data-coasta-faq-category-link]')];
    const normalize = (value) => (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
    questions.forEach((question) => question.removeAttribute('hidden'));
    groups.forEach((group) => group.removeAttribute('hidden'));
    if (empty) empty.hidden = true;
    const applySearch = () => {
      const query = normalize(input?.value);
      let visibleCount = 0;
      questions.forEach((question) => {
        const haystack = normalize(question.dataset.faqSearch || question.textContent);
        const visible = !query || haystack.includes(query);
        question.hidden = !visible;
        if (visible) visibleCount += 1;
        const details = question.querySelector('details');
        if (details) details.open = Boolean(query && visible);
      });
      groups.forEach((group) => {
        const groupQuestions = [...group.querySelectorAll('[data-coasta-faq-question]')];
        group.hidden = groupQuestions.length > 0 && groupQuestions.every((question) => question.hidden);
      });
      if (clear) clear.hidden = !query;
      if (empty) empty.hidden = !query || visibleCount !== 0;
    };
    const clearSearch = () => { if (!input) return; input.value = ''; applySearch(); input.focus(); };
    input?.addEventListener('input', applySearch);
    input?.addEventListener('keydown', (event) => { if (event.key === 'Escape') clearSearch(); });
    clear?.addEventListener('click', clearSearch);
    reset?.addEventListener('click', clearSearch);
    questions.forEach((question) => {
      const details = question.querySelector('details');
      if (!details) return;
      details.addEventListener('toggle', () => {
        if (!details.open || input?.value.trim()) return;
        const group = details.closest('.coasta-faq-group');
        group?.querySelectorAll('details[open]').forEach((item) => { if (item !== details) item.open = false; });
      });
    });
    categoryLinks.forEach((link) => link.addEventListener('click', () => categoryLinks.forEach((item) => item.classList.toggle('is-active', item === link))));
    const categories = categoryLinks.map((link) => { const id = link.getAttribute('href'); return id ? { link, target: section.querySelector(id) } : null; }).filter((item) => item?.target);
    if (categories.length && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        const current = entries.filter((entry) => entry.isIntersecting).sort((a,b) => Math.abs(a.boundingClientRect.top)-Math.abs(b.boundingClientRect.top))[0];
        if (!current) return;
        const match = categories.find((item) => item.target === current.target);
        if (!match) return;
        categoryLinks.forEach((item) => item.classList.toggle('is-active', item === match.link));
      }, { rootMargin:'-22% 0px -64% 0px', threshold:0 });
      categories.forEach((item) => observer.observe(item.target));
    }
  };
  const boot = () => document.querySelectorAll('[data-coasta-faq-section]').forEach(initFaq);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once:true }); else boot();
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.('[data-coasta-faq-section]') || (event.target.matches?.('[data-coasta-faq-section]') ? event.target : null);
    if (section) initFaq(section);
  });
})();
